/* Display metadata (label + logo) per connectable app, keyed by provider. The
   list of AVAILABLE apps still comes from the backend (/api/integrations); this
   only supplies the logo asset + a display label. Add an entry when a new app
   ships a logo. Logos live in /public.

   App-catalog metadata, used by the Apps page and the Agent-Studio's ready-made
   skills library (agentStudio/PackageLibrary.js). */
export const PROVIDER_META = {
  calendly: { label: 'Calendly', logo: '/calendly-logo.png' },
  calcom: { label: 'Cal.com', logo: '/calcom-logo.png' },
  hubspot: { label: 'HubSpot', logo: '/hubspot-logo.png' },
  stripe: { label: 'Stripe', logo: '/stripe-logo.png' },
  mailchimp: { label: 'Mailchimp', logo: '/mailchimp-logo.png' },
  zendesk: { label: 'Zendesk', logo: '/zendesk-logo.png' },
  wix: { label: 'Wix', logo: '/wix-logo.png' },
  // Coming-soon apps (see integration_catalog.py). Shopify reuses the existing
  // /public asset; the two calendars use brand-coloured calendar icons in /public.
  google_calendar: { label: 'Google Calendar', logo: '/google-calendar-logo.svg' },
  microsoft_calendar: { label: 'Outlook Calendar', logo: '/microsoft-calendar-logo.svg' },
  shopify: { label: 'Shopify', logo: '/shopify-logo.svg' },
  // Through the Ultimo Bots WordPress plugin (1.3.0+): products and the customer's own orders.
  woocommerce: { label: 'WooCommerce', logo: '/woocommerce-logo.png' },
  // Automation platforms (webhook_only in the backend catalog): enabled Apps-hub
  // cards without a Connect flow — a skill reaches them via an http tool.
  // Official brand icons: the Zapier asterisk mark, the Make "M", the n8n nodes.
  zapier: { label: 'Zapier', logo: '/zapier-logo.png' },
  make: { label: 'Make', logo: '/make-logo.png' },
  n8n: { label: 'n8n', logo: '/n8n-logo.png' },
};

export const providerMeta = (key) => PROVIDER_META[key] || null;
